import { getSectionSplitByPage } from '../../../../../features/components/PdfGeneration/generatePdfReport/contentPreparation'
import { cleanUpTemporaryPDFElements, processVideos } from '../../../../../helpers/pdf'
import { getSectionsScreenshots } from '../../../../../features/components/PdfGeneration/generatePdfReport'
import { CARD_LIST_ITEM_CLASSNAME } from '../../../../../constants/pdf'

export const getReportPDFSections = async brandColor => {
  const campaignsSection = getSectionSplitByPage('#right-campaigns-table', 'li', 23)
  const facebookAdsSection = getSectionSplitByPage(
    '#facebook-ad-cards-list',
    `[class^="${CARD_LIST_ITEM_CLASSNAME}"]`,
    5,
    newUl => processVideos(newUl, brandColor)
  )
  const googleAdsSection = getSectionSplitByPage(
    '#google-ad-cards-list',
    `[class^="${CARD_LIST_ITEM_CLASSNAME}"]`,
    5,
    newUl => processVideos(newUl, brandColor)
  )
  const facebookBreakdownSection = getSectionSplitByPage('#facebook_breakdowns', 'li', 23)
  const googleBreakdownSection = getSectionSplitByPage('#google_breakdowns', 'li', 23)
  const tiktokBreakdownSection = getSectionSplitByPage('#tiktok_breakdowns', 'li', 23)
  const dv360BreakdownSection = getSectionSplitByPage('#dv360_breakdowns', 'li', 23)

  // takes DOM elements which will be taken as screenshots for PDF
  const reportSectionHeader = document.querySelector('#rights-report-header')
  const graphsSection = document.querySelector('#graphs-report')
  const sections = [
    // line items could not fit one PDF page, and will be cut by library in unexpected places,
    // so we need to split it by pages manually
    ...campaignsSection,
    reportSectionHeader,
    graphsSection,
    ...facebookBreakdownSection,
    ...facebookAdsSection,
    ...googleBreakdownSection,
    ...googleAdsSection,
    ...tiktokBreakdownSection,
    ...dv360BreakdownSection
  ]

  // create screenshots for each section
  const content = await getSectionsScreenshots(sections)
  // clean up all temporary elements with ".temporary-pdf-wrapper" class
  cleanUpTemporaryPDFElements()

  return content
}
